// ---------------------------------------------------------------------------
// Estilos compartilhados do pacote Inputs V3.
// ---------------------------------------------------------------------------
// Aqui ficam apenas as classes/hooks de estilo genéricos o bastante para
// serem consumidos por mais de um componente da família V3 (tela principal
// InputsV3.js e o futuro InputDrawerV3). Cada componente que precisar de
// estilos muito específicos mantém seu próprio makeStyles local.
// ---------------------------------------------------------------------------

import { makeStyles } from "@material-ui/core/styles";
import { grayColor } from "../../../assets/jss/material-dashboard-pro-react";

// Chip dos badges superiores (Críticos / Em atenção / Não enviados).
// Mantém a "altura slim" e remove o flash de box-shadow no clique/foco.
export const useCounterBadgeStyles = makeStyles(() => ({
  counterChip: {
    height: "22px",
    boxShadow: "none",
    "&:hover": { boxShadow: "none" },
    "&:focus": { boxShadow: "none" },
    "&:active": { boxShadow: "none" },
    "&:focus:not(:active)": { boxShadow: "none" },
    "& .MuiChip-label": {
      paddingLeft: "10px",
      paddingRight: "12px",
    },
    "& .MuiChip-icon": {
      marginLeft: "8px",
      marginRight: "-8px",
    },
  },
}));

// Overlay scrollbar — fina, transparente, aparece só no hover.
// Padrão reutilizado em múltiplas listas roláveis da aplicação
// (AlignmentSession, card de responsáveis, timeline do drawer, etc).
// Sempre que for usada em conjunto com uma interação de scroll por wheel
// do mouse, combine com `useNativeWheelScroll` para evitar propagação
// do evento para o ancestral quando a scrollbar é transparente.
export const useOverlayScrollStyles = makeStyles(() => ({
  overlayScroll: {
    overflowY: "auto",
    "@supports (overflow: overlay)": {
      overflowY: "overlay",
    },
    scrollbarWidth: "thin",
    scrollbarColor: "transparent transparent",
    "&:hover": {
      scrollbarColor: grayColor[6] + " transparent",
    },
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "transparent",
      borderRadius: "3px",
      transition: "background 0.2s ease",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: grayColor[6],
    },
  },
}));
